module.exports = __webpack_public_path__ + "img/Flag_of_the_Republic_of_the_Congo.d932b725.svg";